/* eslint-disable no-unused-vars, no-shadow*/
/* eslint-disable camelcase*/
// ! defines all possible routes for each backend call

export const apiRoutes = {
  admin: "/admin-backend",
  auth: {
    login: "/login",
    logout: "/logout",
    send_2fa_code: "/2fa/send-code",
    resend_2fa_code: "/2fa/resend-code",
    verify_2fa_code: "/2fa/verify-code",
    toggle_2fa: "/account/2fa-settings",
    check_password: "/2fa/check-password",
  },
  session: "/session", // retrieve the current session and check if user is still logged in
  on_site_authentication: "on-site-authentication",
  user: "/me", // retrieve user information
  users: "/users",
  book_for_users: "/book",
  certificate_qrcode_verification: "certificates/verify-token",
  certificate_verification: "certificates/verify-data",
  events: "/events",
  events_filter_values: "/events/filter-values",
  events_organization_booking: "/events/events-organization-booking",
  registration: "/registration",
  activate_account: "/activate-account",
  reactivate_account: "/reactivate-account",
  deactivate_account: "/deactivate-account",
  resend_activation_code: "/resend-activation-code",
  forgot_password: "/forgot-password",
  reset_password: "/reset-password",
  change_password: "/change-password",
  change_temporary_password: "/change-temporary-password",
  participants: "/participants",
  participants_csv: "/participants/csv",
  tasks: "/tasks",
  tasks_filter_users: "/tasks/filter-users",
  speakers: "/speakers",
  documents: "/documents",
  documents_default: "/documents/default",
  document_by_id: "/documents/get-document-by-id",
  booking: "/bookings",
  booking_all: "/bookings/all",
  lectures: "/lectures",
  cart_items: "/cart-items",
  cart: "/cart",
  // TODO: Decide whether old invoice service is still needed
  invoice: "/invoice",
  organization_invoice: "/organization-invoices",
  invoice_correction: "/invoice-correction",
  contact: "/contact",
  favorites: "/favorites",
  favorites_count: "/favorites/count",
  templates_event: "/event-templates",
  templates_task: "/task-templates",
  checklist: "/checklist",
  billing_addresses: "/billing-addresses",
  link_account: "/link-account",
  link_account_validate: "/link-account/validate-account-link",
  link_account_confirmation: "/link-account/confirmation",
  participation_types: "/participation-types",
  statistics: "/statistics",
  elearning_root: "/elearning",
  blended_learnings: "/blended-learnings",
  elearnings: "/e-learnings",
  pinboard: "/pinboard",
  pinboard_comments: "/pinboard-comments",
  pinboard_activated: "/is-pinboard-activated",
  dashboard: "/dashboard",
  dashboard_updates: "/dashboard-updates",
  moodle_login: "/moodle-login",
  moodle_data: "/moodle-data",
  //TODO: saving captures
  authentication_captures: "/auth-captures",
  group_membership_document: "/group-membership-documents",
  group_membership_document_types: "/group-membership-document-types",
  profile: "/profile",
  invoices: "/invoices",
  cancellation_invoices: "/cancellation-invoices",
  invoices_count: "/invoices_count",
  orders: "/orders",
  discounts: "/discounts",
  paypal: "/paypal",
  certificate_types: "/certificate-types",
  organization: "/organization",
  organization_bulk_booking: "/organization-bulk-user-event-booking",
  organization_types: "/organization-type",
  organization_settings: "/organization-settings",
  organization_membership: "/membership",
  organization_generate_start_instructions: "/generate-start-instructions",
  organization_start_instructions_status_prefix: "/start-instructions",
  organization_download_start_instructions_prefix: "/download-start-instructions",
  add_user_to_organization: "/add-membership",
  accept_membership: "/accept",
  patch_membership_admin_status: "/patch_admin_status",
  organization_event_participations: "/organization-event-participations",
  download_template: "/download-template",
  maintenance: "/maintenance",
  minimum_age: "/minimum-age",
  frontend_logger: "/frontend-logger",
  payment_methods: "/payment-methods",
  prepayment_confirmation: "/prepayment-confirmation",
  meta_data: "/meta-data",
  bund_id_auth: "/saml/login/",
  bund_id_check: "/saml/bund-id",
  bund_id_session: "/saml/bund-id-session",
  bund_id_request: "/saml/bund-id-request",
  create_bund_id_request: "/saml/create-bund-id-request",
  feature_flags: "/feature-flags",
  register_event_participant: "/register-event-participant",
  certificate: "/certificates",
  stripe_checkout: "/create-stripe-payment",
  stripe_session_status: "/stripe-session-status",
  stripe_data: "/stripe-data",
  user_language: "/user-language",
  password_policy: "/password-policy",
  course_languages: "/course-language",
  course_subtitles: "/course-subtitle",
  topics: "/topics",
  tags: "/tags",
};

export enum ApiVersion {
  Default = "/api",
  Version_0_1 = "/api/v0.1",
}

export default apiRoutes;
